import i18n from 'i18n'
import { isAnyOf } from '@reduxjs/toolkit'
import listenerMiddleware from 'listenerMiddleware'

import { api } from 'api/api'
import * as sessionUserSelector from 'selectors/sessionUser'
import { setMomentLocale } from 'utils/time'

listenerMiddleware.startListening({
  matcher: isAnyOf(
    api.endpoints?.updateSessionUser?.matchFulfilled,
    api.endpoints?.restoreSession?.matchFulfilled,
    api.endpoints?.authUser?.matchFulfilled,
  ),
  effect: (action, listenerApi) => {
    const state = listenerApi.getState()

    const locale = sessionUserSelector.locale(state)
    const timeFormat24 = sessionUserSelector.timeFormat24(state)

    setMomentLocale(locale, timeFormat24)
    i18n.changeLanguage(locale)
  },
})
